module.exports = __webpack_public_path__ + "static/media/mcorm.b29a55cf.png";